import React, { useState } from "react";
import SideDrawer from "../../Components/Navigation/SideDrawer/SideDrawer";
import Toolbar from "../../Components/Navigation/Navbars/ToolBar";

const Layout = ({ children }) => {
  const [sideDrawerVisible, setSideDrawerVisible] = useState(false);
  const sideDrawerHandler = () => setSideDrawerVisible(false);
  const toggleHandler = () => setSideDrawerVisible(!sideDrawerVisible);
  
  let urlElements = window.location.href.split("/");
  let pageName = urlElements[3]; 

  const hideNavbarOn = ["db", "freelance-workspace"];

  const showNavbar = !hideNavbarOn.includes(pageName);

  return (
    <>
      {showNavbar ? (
        <>
          <Toolbar open={toggleHandler} scroll={300} />
          <SideDrawer close={sideDrawerHandler} open={sideDrawerVisible} />
          <main>{children}</main>
        </>
      ) : (
        <main>{children}</main>
      )}
    </>
  );
};

export default Layout;